export type BlogLang = "fr" | "en";

export const blogContent = {
  fr: {
    hero: {
      breadcrumbHome: "Accueil",
      breadcrumbBlog: "Blog",
      breadcrumbCategory: "Guide d'achat",
      categoryTag: "Comparatif 2026",
      title:
        "Meilleure application de reçu en 2026 : pourquoi vous devriez arrêter de gérer vos factures comme un comptable",
      subtitle:
        "Une comparaison honnête des outils du marché — et pourquoi la majorité d'entre eux n'ont jamais été pensés pour vous.",
      author: "Équipe ReFound",
      date: "20 mai 2026",
      readingTime: "8 min de lecture",
    },
    intro: {
      p1Start:
        "Nous avons tous ce fameux tiroir ou cette boîte à chaussures qui déborde de reçus papier. Parfois, l'encre s'efface avant même qu'on ait pu ramener l'article en magasin. D'autres fois, on se retrouve devant un relevé bancaire avec une ligne obscure indiquant ",
      p1End:
        " sans avoir la moindre idée de ce qu'on a acheté chez Canadian Tire ou Home Depot trois semaines plus tôt.",
      p2Start: "Si vous cherchez la ",
      p2Strong: "meilleure application de reçu",
      p2End:
        ", vous avez probablement remarqué que le marché est inondé de deux types d'outils : les logiciels de comptabilité lourds pour les entreprises, et les applications de cash back qui s'intéressent d'un peu trop près à votre vie privée.",
      quote:
        "Qu'en est-il pour vos achats personnels du quotidien, vos retours de marchandises et le suivi de vos garanties ?",
      p3:
        "Découvrez notre comparatif des applications de scan de facture pour comprendre comment une nouvelle génération d'applications change la donne sans marchander vos données.",
    },
    comparison: {
      title: "Comparatif : quelle application de reçu choisir en 2026 ?",
      caption:
        "Fig. 1 — Comparaison des quatre grandes catégories d'applications de gestion de reçus disponibles au Canada.",
      colCriteria: "Fonctionnalités",
      colExpense: "Apps de notes de frais",
      colExpenseSub: "Type Expensify — pour le travail",
      colScanner: "Scanners basiques",
      colScannerSub: "Type Adobe Scan — numérisation",
      colCashback: "Apps de cash back",
      colCashbackSub: "Type Checkout 51, Receipt Hog",
      mobileExpense: "Notes de frais (Expensify)",
      mobileScanner: "Scanners (Adobe Scan)",
      mobileCashback: "Cash back (Checkout 51, Receipt Hog)",
      yes: "Oui",
      no: "Non",
      rows: [
        {
          feature: "Objectif principal",
          refound: "Retours, garanties & gestion d'achats",
          cashback: "Gagner quelques sous en échange de vos reçus",
          expense: "Rapports de dépenses & taxes pro",
          scanner: "Numérisation simple en PDF",
        },
        {
          feature: "Respect de la vie privée",
          refound: "Strict — aucune revente de données",
          cashback: "Faible — revend vos données d'achat aux marques",
          expense: "Professionnel — données d'entreprise sécurisées",
          scanner: "Élevé — fichiers stockés dans votre cloud",
        },
        {
          feature: "Lecture des reçus",
          refound: "Intelligente — vrais noms & images des produits",
          cashback: "Marketing — cherche les marques partenaires",
          expense: "Comptable — extrait le total et la TVA",
          scanner: "Brute — numérise le texte sans le trier",
        },
        {
          feature: "Gestion des retours & garanties",
          refound: "Oui — alertes + code-barres caisse",
          cashback: "Non",
          expense: "Non",
          scanner: "Non",
        },
        {
          feature: "Prix",
          refound: "Gratuit",
          cashback: "« Gratuit » — monétisé par vos données",
          expense: "Payant — abonnement mensuel",
          scanner: "Gratuit avec options payantes",
        },
      ],
    },
    problem: {
      problems: [
        {
          title:
            "Le problème avec les applications de notes de frais traditionnelles",
          paragraphs: [
            "Lorsque l'on cherche un scanner de ticket de caisse OCR ou une top application note de frais 2026, Google propose souvent des mastodontes de la comptabilité. Bien que ces outils soient d'une efficacité redoutable pour les entreprises, ils s'avèrent lourds pour un particulier. Ils classent vos achats par catégories fiscales (frais de déplacement, repas d'affaires) plutôt que par produits, et la plupart des fonctionnalités avancées nécessitent un abonnement mensuel coûteux.",
          ],
        },
        {
          title:
            "Le piège des applications de cash back : vos données ont un prix",
          paragraphs: [
            "À première vue, les applications de reçus de style cash back semblent attrayantes. On scanne son reçu, et on accumule des fractions de dollars. Mais posez-vous la question : comment ces applications gagnent-elles de l'argent ? La réponse est simple : elles vendent vos données de consommation.",
            "En scannant vos factures, vous leur donnez un accès illimité à vos habitudes de vie, aux marques que vous préférez, à la fréquence de vos achats et à votre budget. Ces profils ultra-précis sont ensuite revendus à des régies publicitaires et à de grands fabricants pour vous cibler encore plus efficacement. Sans oublier que pour récupérer votre argent, vous devez souvent atteindre un seuil minimal (souvent 20 $), ce qui prend des mois pour un gain minime.",
          ],
        },
      ],
    },
    refound: {
      title:
        "ReFound : l'assistant de magasinage grand public qui protège votre portefeuille et votre vie privée",
      intro:
        "Pour contrer à la fois la lourdeur comptable et l'espionnage publicitaire, l'application canadienne ReFound a pris le contre-pied total du marché. Plutôt que de s'adresser aux entreprises ou aux courtiers de données, elle s'adresse directement aux consommateurs avec une promesse de valeur d'usage.",
      conceptLabel: "Le concept :",
      conceptText:
        " transformer vos reçus de caisse passifs en outils intelligents pour faciliter vos retours et suivre vos garanties, dans le respect absolu de votre vie privée.",
      crucialBadge: "Critère crucial",
      features: [
        {
          primary: true,
          title: "Une politique stricte de « No-Data-Selling »",
          paragraphs: [
            "C'est le critère crucial. ReFound est un outil de productivité personnelle, pas une régie publicitaire déguisée. Vos données d'achat ne sont jamais vendues, louées ou partagées avec des tiers. Ce qui est écrit sur votre reçu ne regarde que vous et votre commerçant.",
          ],
        },
        {
          title: "Fini le charabia : place aux reçus visuels",
          paragraphs: [
            "La plupart des applications lisent le texte brut sans le comprendre. ReFound utilise une technologie avancée pour décoder les reçus. L'application transforme les codes de produits obscurs (les fameux SKU) en véritables noms d'articles accompagnés d'images claires. Vous savez instantanément ce que contient chaque reçu en un seul coup d'œil.",
          ],
        },
        {
          title: 'Une vue « prête pour le retour » en magasin',
          paragraphs: [
            "C'est la fonctionnalité phare de ReFound. L'application intègre et suit automatiquement les politiques de retour des grands détaillants canadiens (IKEA, Walmart, Canadian Tire, Costco, RONA, Home Depot, Best Buy, Décathlon, BMR, Canac, Dollarama, Tigre Géant, etc.).",
          ],
          bullets: [
            "Elle calcule pour vous la date limite pour rapporter un article.",
            "Elle vous envoie un rappel avant qu'il ne soit trop tard.",
            "En magasin, l'application génère un code-barres scannable directement par le caissier, avec l'article concerné surligné visuellement. Plus de stress à la caisse.",
          ],
        },
        {
          title: "Le gardien de vos garanties",
          paragraphs: [
            "Un appareil électronique qui lâche après 6 mois ? Une souffleuse à neige défectueuse ? Trouver la garantie papier est souvent un parcours du combattant. ReFound extrait les informations de garantie de vos reçus et vous alerte avant leur expiration. Vous ne perdrez plus jamais d'argent à cause d'un papier égaré ou effacé.",
          ],
        },
      ],
    },
    criteria: {
      title: "Les 3 critères qui départagent vraiment ces applications",
      intro:
        "Au-delà des catégories d'outils, trois critères techniques départagent les applications de reçus. C'est sur ces trois fondamentaux que ReFound a été construit :",
      items: [
        {
          title: "1. La précision de l'OCR",
          text:
            "Une lecture erronée, c'est une preuve d'achat qu'on ne peut plus utiliser. ReFound est propulsé par Google Vision, au sommet des benchmarks OCR indépendants (98 % de précision), et par Gemini pour les reçus difficiles à lire.",
          href: "/fonctionnalites/precision-ocr",
          linkLabel: "Voir la précision OCR de ReFound",
        },
        {
          title: "2. Le stockage cloud sécurisé",
          text:
            "Vos reçus ne devraient pas disparaître avec un téléphone perdu ou brisé. Ils restent privés et protégés, avec la possibilité d'activer la sauvegarde cloud pour les retrouver en cas de besoin. La base de données principale de ReFound est hébergée au Canada.",
          href: "/fonctionnalites/stockage-cloud-securise",
          linkLabel: "Voir le stockage cloud sécurisé",
        },
        {
          title: "3. La catégorisation et les filtres",
          text:
            "Catégories automatiques et personnalisées, filtres par magasin, carte de paiement ou montant, et recherche par vrai nom de produit plutôt que par code SKU.",
          href: "/fonctionnalites/categorisation-filtres",
          linkLabel: "Voir la catégorisation et les filtres",
        },
      ],
      guideText: "Pour l'analyse complète de ces trois critères, avec comparatif :",
      guideHref: "/blog/comment-choisir-application-recus",
      guideLabel: "Comment choisir une application de reçus : 3 critères essentiels (2026)",
    },
    verdict: {
      title: "Verdict : quelle application de reçu devriez-vous installer ?",
      intro: "Le choix de votre application dépend uniquement de votre profil :",
      chooseWord: "Choisissez",
      choices: [
        {
          label: "une application de note de frais pro",
          example: "(comme Expensify)",
          description:
            "si vous êtes salarié et devez vous faire rembourser des dépenses par votre employeur.",
        },
        {
          label: "une application de cash back",
          example: "(comme Checkout 51)",
          description:
            "si vous acceptez que vos habitudes d'achat soient analysées et revendues en échange de quelques dollars par an.",
        },
        {
          label: "ReFound",
          example: "",
          description:
            "si vous êtes un particulier ou une famille au Canada, que vous souhaitez un outil gratuit pour simplifier vos retours, protéger vos garanties de manière ultra-efficace, tout en gardant vos données privées et protégées.",
        },
      ],
      ctaP1Start: "L'application ",
      ctaP1Strong: "ReFound",
      ctaP1End:
        " est disponible gratuitement sur iPhone et Android. Prêt à vider votre portefeuille de ses reçus papier sans vendre votre vie privée ?",
      ctaP2:
        "Téléchargez l'application et reprenez le contrôle de vos achats dès aujourd'hui.",
      ctaButton: "Télécharger sur l'App Store",
      ctaButtonPlay: "Disponible sur Google Play",
      authorName: "Équipe ReFound",
      authorBio:
        "Nous écrivons sur la gestion des reçus, les retours en magasin et les droits des consommateurs canadiens.",
    },
  },

  en: {
    hero: {
      breadcrumbHome: "Home",
      breadcrumbBlog: "Blog",
      breadcrumbCategory: "Buying guide",
      categoryTag: "2026 Comparison",
      title:
        "Best receipt app in 2026: why you should stop managing your bills like an accountant",
      subtitle:
        "An honest comparison of what's on the market — and why most of these tools were never built for you.",
      author: "ReFound Team",
      date: "May 20, 2026",
      readingTime: "8 min read",
    },
    intro: {
      p1Start:
        "We all have that infamous drawer or shoebox overflowing with paper receipts. Sometimes the ink fades before you can even return the item to the store. Other times you're staring at a bank statement with a cryptic line that reads ",
      p1End:
        " without the faintest idea what you bought at Canadian Tire or Home Depot three weeks earlier.",
      p2Start: "If you're looking for the ",
      p2Strong: "best receipt app",
      p2End:
        ", you've probably noticed the market is flooded with two types of tools: heavy accounting software built for businesses, and cash-back apps that take a little too much interest in your private life.",
      quote:
        "But what about your everyday personal purchases, your in-store returns and your warranty tracking?",
      p3:
        "Read our comparison of receipt scanner apps to understand how a new generation of apps is changing the game without trading your data away.",
    },
    comparison: {
      title: "Comparison: which receipt app should you choose in 2026?",
      caption:
        "Fig. 1 — A side-by-side look at the four main categories of receipt apps available in Canada.",
      colCriteria: "Features",
      colExpense: "Expense report apps",
      colExpenseSub: "Expensify-style — for work",
      colScanner: "Basic scanners",
      colScannerSub: "Adobe Scan-style — digitizing",
      colCashback: "Cash back apps",
      colCashbackSub: "Checkout 51, Receipt Hog-style",
      mobileExpense: "Expense (Expensify)",
      mobileScanner: "Scanners (Adobe Scan)",
      mobileCashback: "Cash back (Checkout 51, Receipt Hog)",
      yes: "Yes",
      no: "No",
      rows: [
        {
          feature: "Main purpose",
          refound: "Returns, warranties & purchase tracking",
          cashback: "Earn a few cents in exchange for your receipts",
          expense: "Pro expense reports & taxes",
          scanner: "Simple PDF scanning",
        },
        {
          feature: "Privacy",
          refound: "Strict — no data resale",
          cashback: "Low — sells your purchase data to brands",
          expense: "Professional — secured business data",
          scanner: "High — files stored in your cloud",
        },
        {
          feature: "Receipt reading",
          refound: "Smart — real product names & images",
          cashback: "Marketing — looks for partner brands",
          expense: "Accounting — extracts total & tax only",
          scanner: "Raw — unsorted text",
        },
        {
          feature: "Returns & warranty handling",
          refound: "Yes — alerts + checkout barcode",
          cashback: "No",
          expense: "No",
          scanner: "No",
        },
        {
          feature: "Price",
          refound: "Free",
          cashback: '"Free" — monetized via your data',
          expense: "Paid — monthly subscription",
          scanner: "Free with paid options",
        },
      ],
    },
    problem: {
      problems: [
        {
          title: "The problem with traditional expense report apps",
          paragraphs: [
            "When you search for an OCR receipt scanner or a top expense app for 2026, Google often surfaces accounting heavyweights. While these tools are extremely efficient for businesses, they're clunky for an individual. They sort your purchases by tax categories (travel expenses, business meals) rather than by product, and most advanced features require a costly monthly subscription.",
          ],
        },
        {
          title: "The cash-back app trap: your data has a price",
          paragraphs: [
            "At first glance, cash-back receipt apps look appealing. You scan your receipt, you accumulate fractions of a dollar. But ask yourself: how do these apps actually make money? The answer is simple: they sell your consumption data.",
            "By scanning your receipts, you give them unlimited access to your lifestyle habits, your preferred brands, the frequency of your purchases and your budget. These ultra-precise profiles are then resold to ad networks and large manufacturers to target you even more effectively. Plus, to actually cash out, you usually need to hit a minimum threshold (often $20), which takes months to reach for a tiny payout.",
          ],
        },
      ],
    },
    refound: {
      title:
        "ReFound: the consumer shopping assistant that protects your wallet and your privacy",
      intro:
        "To counter both accounting bloat and ad-driven spying, the Canadian app ReFound took the opposite path from the rest of the market. Instead of targeting businesses or data brokers, it speaks directly to consumers with a promise of real, everyday usefulness.",
      conceptLabel: "The idea:",
      conceptText:
        " turn your passive paper receipts into smart tools that simplify your returns and track your warranties, with absolute respect for your privacy.",
      crucialBadge: "Critical criterion",
      features: [
        {
          primary: true,
          title: 'A strict "No-Data-Selling" policy',
          paragraphs: [
            "This is the critical point. ReFound is a personal productivity tool, not a disguised ad network. Your purchase data is never sold, rented or shared with third parties. What's on your receipt is between you and your retailer.",
          ],
        },
        {
          title: "Goodbye gibberish: meet visual receipts",
          paragraphs: [
            "Most apps just read the raw text of a receipt without understanding it. ReFound uses advanced recognition technology to decode receipts. The app turns cryptic product codes (the famous SKUs) into real product names with clear images. You know instantly what's on each receipt at a glance.",
          ],
        },
        {
          title: 'A "ready-to-return" view for the store',
          paragraphs: [
            "This is ReFound's flagship feature. The app automatically integrates and tracks the return policies of major Canadian retailers (IKEA, Walmart, Canadian Tire, Costco, RONA, Home Depot, Best Buy, Decathlon, BMR, Canac, Dollarama, Giant Tiger, etc.).",
          ],
          bullets: [
            "It calculates the deadline to bring an item back.",
            "It sends you a reminder before it's too late.",
            "In-store, the app generates a barcode the cashier can scan directly, with the relevant item visually highlighted. No more checkout stress.",
          ],
        },
        {
          title: "The guardian of your warranties",
          paragraphs: [
            "An electronic device that dies after 6 months? A defective snow blower? Finding the paper warranty is often a nightmare. ReFound extracts warranty information from your receipts and alerts you before they expire. You'll never lose money again because of a misplaced or faded piece of paper.",
          ],
        },
      ],
    },
    criteria: {
      title: "The 3 criteria that really separate these apps",
      intro:
        "Beyond tool categories, three technical criteria separate receipt apps. These are the three fundamentals ReFound was built on:",
      items: [
        {
          title: "1. OCR accuracy",
          text:
            "A misread receipt is proof of purchase you can no longer use. ReFound is powered by Google Vision, top-ranked in independent OCR benchmarks (98% accuracy), plus Gemini for hard-to-read receipts.",
          href: "/en/features/ocr-accuracy",
          linkLabel: "See ReFound's OCR accuracy",
        },
        {
          title: "2. Secure cloud storage",
          text:
            "Your receipts should not vanish with a lost or broken phone. They stay private and protected, with the option to turn on cloud backup so you can find them when you need them. ReFound's main database is hosted in Canada.",
          href: "/en/features/secure-cloud-storage",
          linkLabel: "See the secure cloud storage",
        },
        {
          title: "3. Categories and filters",
          text:
            "Automatic and custom categories, filters by store, payment card or amount, and search by real product name rather than SKU code.",
          href: "/en/features/categories-filters",
          linkLabel: "See the categories and filters",
        },
      ],
      guideText: "For the full breakdown of these three criteria, with a comparison table:",
      guideHref: "/en/blog/how-to-choose-receipt-app",
      guideLabel: "How to Choose a Receipt App: 3 Key Criteria (2026)",
    },
    verdict: {
      title: "Verdict: which receipt app should you install?",
      intro: "The right app depends entirely on your profile:",
      chooseWord: "Choose",
      choices: [
        {
          label: "a pro expense app",
          example: "(like Expensify)",
          description:
            "if you're an employee who needs to get reimbursed for expenses by your employer.",
        },
        {
          label: "a cash back app",
          example: "(like Checkout 51)",
          description:
            "if you're OK with your shopping habits being analyzed and resold in exchange for a few dollars a year.",
        },
        {
          label: "ReFound",
          example: "",
          description:
            "if you're an individual or family in Canada looking for a free tool to simplify your returns, protect your warranties effectively, while keeping your data private and protected.",
        },
      ],
      ctaP1Start: "The ",
      ctaP1Strong: "ReFound",
      ctaP1End:
        " app is available for free on iPhone and Android. Ready to clear your wallet of paper receipts without selling your privacy?",
      ctaP2:
        "Download the app and take back control of your purchases today.",
      ctaButton: "Download on the App Store",
      ctaButtonPlay: "Get it on Google Play",
      authorName: "ReFound Team",
      authorBio:
        "We write about receipt management, in-store returns and Canadian consumer rights.",
    },
  },
} as const;
